module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation2.59b363ab.png";